function V1() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        В1 Здатність до навчання впродовж життя
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        В1.1 Здатність до саморефлексії та самооцінювання управлінської діяльності
                    </td>
                    <td>
                        В1.1.31 Сутність, зміст, методи та способи здійснення саморефлексії та самооцінювання власної
                        професійної діяльності
                    </td>
                    <td>
                        В1.1.У1 Аналізувати, усвідомлювати, узагальнювати результати власної професійної діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        В1.1.32 Професіний стандарт та вимог до управлінської діяльності
                    </td>
                    <td>
                        В1.1.У2 Визначати відповідність власних професійних компетент-ностей вимогам професійного
                        стандарту та виявляти труднощі, усувати недоліки власної діяльності
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        В1.2 Здатність планувати та реалізовувати індивідуальний професійний розвиток та самоосвіту
                    </td>
                    <td>
                        В1.2.31 Нормативно-правове забезпечення підвищення кваліфікації педагогічних працівників
                    </td>
                    <td>
                        В1.2.У1 Визначати індивідуальну потребу та планувати професійний розвиток для досягнення його
                        стратегічних і оперативних цілей
                    </td>
                </tr>
                <tr>
                    <td>
                        В1.2.32 Основні принципи, функції, форми і методи самоосвіти
                    </td>
                    <td>
                        В1.2.У2 Обирати форми, способи професійного розвитку, визначати умови та ресурси професійного
                        розвитку впродовж життя
                    </td>
                </tr>
            </table>
        </main>
)
}

export {
    V1
}